import React, { Component, Fragment } from 'react';
import { withTranslation } from "react-i18next";
import Wrapper from './../../../common/component/Wrapper';
import * as Func from '../../../../../helpers/functions';
import { ListComponent } from '../../../common/component/Index';
import SupplierCategory from '../../../../../models/SupplierCategory';
import { Icon, Menu, Tooltip } from 'antd';
import * as HMS from "../../../common/component/Index";
import { PATHS } from '../../../../../constants/Define';
import Dropdown from '../../../common/component/Dropdown';
import { Link } from 'react-router-dom';
import Modal from '../../../common/component/Modal';
import EllipsisText from '../../../common/component/EllipsisText';

const defaultState = {

};

const ListCols = [
    'name', 'code', 'description', 'categoryKeys'
];
const ModelFields = Object.getOwnPropertyNames(new SupplierCategory());

class CategoryList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: Func.getTitleTable(ListCols, ['action'], ['description']),
            modelItem: ModelFields,
            componentTable: {
                name: {
                    key: 'name',
                    fixed: 'left',
                    render: (name, record)=> name && <EllipsisText title={name} content={name} contentMaxWidth={600}
                    overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                code: {
                    key: 'code',
                },
                categoryKeys: {
                    key: 'categoryKeys',
                    render: (categoryKeys, record) => {
                        let txt = '';
                        if(categoryKeys && categoryKeys.length > 0){
                            let lengthTmp = categoryKeys.length;
                            txt = lengthTmp === 1 ? `${lengthTmp} Key` : `${lengthTmp} Keys`;
                        }
                        return txt;
                    }
                },
                action: {
                    width: 100,
                    align: 'center',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
        };
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeCategory = () => {
            return this.props.onDeleteSupplierCategory && this.props.onDeleteSupplierCategory(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.supplierCategory.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeCategory,
            });
        };
        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            permisions && permisions.allowUpdate &&
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.SUPPLIER_CATEGORY.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }
                        {
                            permisions && permisions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }

    render(){
        const { t, loading, pagination, supplierCategories } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;

        return(
            <Wrapper className="mt-2">
                <ListComponent
                    tableKey="ticket-list"
                    classParent="m-0 p-0 col-md-12" classChildren="p-0"
                    marginTop={'0'} marginBottom={'0'}
                    loading={{ spinning: loading, size: 'large' }}
                    rowKey={(record, k) => record.id ? record.id : k}
                    dataSource={Func.getDataSource(supplierCategories || [], modelItem)}
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'supplierCategory'
                    })}
                    pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, pageSize: pagination.pageSize }}
                    onChange={this.props.onChange}
                    componentTableList={{}}
                />
            </Wrapper>
        )
    
    }
}

export default withTranslation()(CategoryList);